export default __webpack_public_path__ + "static/media/1.fc2465b0.svg";